/*
 * Title: Auth/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Auth component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import Index from "@containers/Index";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "@components/Loader";

type Props = {
  name: string;
};

const IndexPage: React.FC<Props> = (props) => {

  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  React.useEffect(()=>{
    if(query.get("returnTo")){
      navigate(query.get("returnTo"))
    }
  }, []);
  
 
  return (
    <div className="bg-[#F6F2E9] overflow-hiden h-full lg:min-h-screen min-h-[100vh] lg:max-h-[100vh] max-h-[100vh] relative">

      {/*Splash screen section started*/}
      {query.get("returnTo")?
      <div className="flex items-center justify-center bg-[#F6F2E9] h-screen overflow-auto">
					<Loader height={30} width={30} white={false} creator={true} />
				</div>:

      <Index />
      }

      {/*Splash screen section end*/}
    </div>
  );
};

export default IndexPage;
